import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountGroupsComponent } from './accountGroups/accountGroups.component';
import { CreateOrEditAccountGroupModalComponent } from './accountGroups/create-or-edit-accountGroup-modal.component';
import { AccountSubGroupsComponent } from './accountSubGroups/accountSubGroups.component';
import { CreateOrEditAccountSubGroupModalComponent } from './accountSubGroups/create-or-edit-accountSubGroup-modal.component';
import { ChartOfAccountsComponent } from './chartOfAccounts/chartOfAccounts.component';
import { CreateOrEditChartOfAccountComponent } from './chartOfAccounts/create-or-edit-chartOfAccount.component';
import { CreateOrEditJournalVoucherComponent } from './journalVoucher/create-or-edit-journalvoucher.component';
import { JournalVouchersComponent } from './journalVoucher/journalvouchers.component';
import { PostedJournalVouchersComponent } from './postedJournalVoucher/postedjournalvouchers.component';
import { PurchaseNotesComponent } from './purchaseNotes/purchasenotes.component';
import { CreateOrEditPurchaseNotesComponent } from './purchaseNotes/create-or-edit-purchasenotes.component';
import { BalanceSheetComponent } from './reports/balance-sheet/balance-sheet.component';
import { GeneralLedgerComponent } from './reports/general-ledger/general-ledger.component';
import { ProfitAndLossComponent } from './reports/profit-and-loss/profit-and-loss.component';
import { TrialBalanceComponent } from './reports/trial-balance/trial-balance.component';
import { SalesNotesComponent } from './salesNotes/salesnotes.component';
import { CreateOrEditSalesNotesComponent } from './salesNotes/create-or-edit-salesnotes.component';

const routes: Routes = [
  {
    path: 'accountGroups',
    children: [
      {
        path: '',
        component: AccountGroupsComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditAccountGroupModalComponent,
      }
    ]
  },
  {
    path: 'accountSubGroups',
    children: [
      {
        path: '',
        component: AccountSubGroupsComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditAccountSubGroupModalComponent,
      }
    ]
  },
  {
    path: 'chartOfAccounts',
    children: [
      {
        path: '',
        component: ChartOfAccountsComponent, // list
      },
      {
        path: 'createOrEdit',
        component: CreateOrEditChartOfAccountComponent,
      }
    ]
    },
    {
        path: 'journalVouchers',
        children: [
            {
                path: '',
                component: JournalVouchersComponent, // list
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditJournalVoucherComponent,
            }
        ]
    },
    {
        path: 'postedjournalVouchers',
        children: [
            {
                path: '',
                component: PostedJournalVouchersComponent, // list
            }
        ]
    },
    {
        path: 'purchaseNotes',
        children: [
            {
                path: 'invoices/:type',
                component: PurchaseNotesComponent, // list
                runGuardsAndResolvers: 'paramsChange'
            },
            {
                path: 'creditNotes/:type',
                component: PurchaseNotesComponent, // list
                runGuardsAndResolvers: 'paramsChange'
            },
            {
                path: 'paymentToOthers/:type',
                component: PurchaseNotesComponent, // list
                runGuardsAndResolvers: 'paramsChange'
            },
            {
                path: '',
                component: PurchaseNotesComponent, // list
                runGuardsAndResolvers: 'paramsChange'
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditPurchaseNotesComponent,
            }
        ]
    },
    {
        path: 'salesNotes',
        children: [
            {
                path: 'invoices/:type',
                component: SalesNotesComponent, // list
                runGuardsAndResolvers: 'paramsChange'
            },
            {
                path: 'creditNotes/:type',
                component: SalesNotesComponent, // list
                runGuardsAndResolvers: 'paramsChange'
            },
            {
                path: 'receiptfromothers/:type',
                component: SalesNotesComponent, // list
                runGuardsAndResolvers: 'paramsChange'
            },
            {
                path: '',
                component: SalesNotesComponent, // list
                runGuardsAndResolvers: 'paramsChange'
            },
            {
                path: 'createOrEdit',
                component: CreateOrEditSalesNotesComponent,
            }
        ]
    },
    {
        path: 'balance-sheet',
        children: [
            {
                path: '',
                component: BalanceSheetComponent, 
            }
        ]
    },
    {
        path: 'general-ledger',
        children: [
            {
                path: '',
                component: GeneralLedgerComponent, 
            }
        ]
    },
    {
        path: 'profit-and-loss',
        children: [
            {
                path: '',
                component: ProfitAndLossComponent, 
            }
        ]
    },
    {
        path: 'trial-balance',
        children: [
            {
                path: '',
                component: TrialBalanceComponent, 
            }
        ]
    },
    
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule { }
